import React, { useMemo, useState } from 'react'
import { Text, View } from 'react-native'
import { IconWarning } from '../../../../../assets/icons'
import Wrapper from '../../../Wrapper'
import { commonColors } from '@linqpal/common-frontend/src/theme'
import { useResponsive } from '../../../../../utils/hooks'
import { Tabs, ViewAddedMethods } from '../BankCardListing/ViewAddedMethods'
import { AddMethodFAB } from '../BankCardListing/AddMethodFAB'
import { Header } from '../BankCardListing/Header'
import { useTranslation } from 'react-i18next'

export const PaymentMethodListing: React.FC = () => {
  const [tab, setTab] = useState(Tabs.BANKS)
  const { mobileWidth } = useResponsive()
  const { t } = useTranslation('global')

  const footerTitle = useMemo(
    () =>
      tab === Tabs.BANKS
        ? t('Wallet.bank-delete-footer')
        : t('Wallet.card-delete-footer'),
    [tab, t],
  )

  return (
    <>
      <Wrapper
        contentContainerStyle={{ paddingHorizontal: 0 }}
        toolbar={<Header />}
      >
        <ViewAddedMethods setTab={setTab} />
      </Wrapper>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'absolute',
          bottom: 0,
          backgroundColor: 'white',
          width: mobileWidth,
          height: 60,
        }}
      >
        <IconWarning />
        <Text
          style={{
            fontWeight: '500',
            fontSize: 12,
            lineHeight: 20,
            color: commonColors.textLight,
            marginLeft: 8,
          }}
        >
          {footerTitle}
        </Text>
        <AddMethodFAB tab={tab} />
      </View>
    </>
  )
}
